export function formatAppDate(iso: string, locale: string): string {
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString(locale);
}

/**
 * A localized count such as "2 steps done". Catalog values list their plural
 * forms by CLDR category, e.g. "one:step done|other:steps done", and never
 * carry the number themselves, so every locale keeps placeholder parity while
 * choosing as many forms as its grammar needs. Missing categories use `other`.
 */
export function formatCount(forms: string, count: number, locale: string): string {
  const byCategory = new Map(
    forms.split('|').map((form) => {
      const split = form.indexOf(':');
      return [form.slice(0, split), form.slice(split + 1)] as const;
    }),
  );
  let category: string = 'other';
  try {
    category = new Intl.PluralRules(locale).select(count);
  } catch {
    // An unknown locale still reads with its `other` form.
  }
  const noun = byCategory.get(category) ?? byCategory.get('other') ?? '';
  return `${new Intl.NumberFormat(locale).format(count)} ${noun}`.trim();
}
